import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const API = `${BACKEND_URL}/api`;

export const WHATSAPP_NUMBER = "918928341661";
export const WHATSAPP_DISPLAY = "+91 89283 41661";

export const SITE_URL =
  typeof window !== "undefined"
    ? window.location.origin
    : "https://www.rsngloves.com";

export const api = axios.create({
  baseURL: API,
});


export function buildWhatsAppLink({
  productName,
  productSlug,
  quantity,
  mobile,
  description,
  weight,
  color,
}) {
  const productLink = `${SITE_URL}/products/${productSlug}`;

  const textLines = [
    "Hello RSN Gloves,",
    "I would like a quotation for:",
    `Product: ${productName}`,
  ];

  if (weight) {
    textLines.push(`Weight: ${weight}`);
  }

  if (color) {
    textLines.push(`Colour: ${color}`);
  }

  textLines.push(
    `Product Link: ${productLink}`,
    `Quantity: ${quantity}`,
    `Mobile Number: ${mobile}`,
    `Requirement: ${description || "—"}`
  );

  const text = textLines.join("\n");

  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    text
  )}`;
}


export async function submitLead(payload) {
  const res = await api.post("/leads", payload);
  return res.data;
}


export async function submitDealerEnquiry(payload) {
  const res = await api.post(
    "/dealer-enquiries",
    payload
  );

  return res.data;
}


export async function adminLogin(password) {
  const res = await api.post(
    "/admin/login",
    { password }
  );

  return res.data;
}


export async function fetchAdminLeads(token) {
  const res = await api.get(
    "/admin/leads",
    {
      headers: {
        "x-admin-token": token,
      },
    }
  );

  return res.data;
}


export async function fetchAdminDealers(token) {
  const res = await api.get(
    "/admin/dealer-enquiries",
    {
      headers: {
        "x-admin-token": token,
      },
    }
  );

  return res.data;
}


export async function fetchAdminStats(token) {
  const res = await api.get(
    "/admin/stats",
    {
      headers: {
        "x-admin-token": token,
      },
    }
  );

  return res.data;
}
